export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e5c08dc678049f32fdb6f42b0ee94cbb878cb479&name=revalidateCommunity!'